module.exports = __webpack_public_path__ + "static/media/esignBanner.c4fc6e58.jpeg";